module.exports = __webpack_public_path__ + "static/media/gosari.0de1ae45.jpg";